export default __webpack_public_path__ + "static/media/top-videos-img-one.e2262571.png";